import type { SVGProps } from 'react';

const SvgSortNewest = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 3.94h-1c0-.55-.45-1-1-1s-1 .45-1 1H9c0-.55-.45-1-1-1s-1 .45-1 1H6c-1.65 0-3 1.35-3 3v11c0 1.65 1.35 3 3 3h4.93c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1v-8h14c0 .55.45 1 1 1s1-.45 1-1v-3c0-1.65-1.35-3-3-3m-13 4v-1c0-.55.45-1 1-1h1c0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1h1c.55 0 1 .45 1 1v1z"
    />
    <path
      fill="currentcolor"
      d="M8.93 12.56a1.2 1.2 0 0 0-.22-.33 1 1 0 0 0-.32-.21c-.25-.1-.52-.1-.77 0-.12.05-.23.12-.32.21-.19.19-.3.45-.3.71 0 .13.03.26.08.38s.12.23.22.33c.09.09.2.16.32.21s.25.08.38.08a1.05 1.05 0 0 0 .71-.29c.09-.1.17-.21.22-.33s.07-.25.07-.38-.02-.26-.07-.38M7.3 15.23c-.19.19-.3.45-.3.71a1.01 1.01 0 0 0 1 1c.26 0 .52-.11.71-.29.09-.1.17-.2.22-.33.05-.12.07-.25.07-.38 0-.26-.1-.52-.29-.71-.37-.37-1.04-.37-1.41 0m3-3c-.19.19-.3.45-.3.71 0 .13.03.26.08.38.02.06.06.12.09.18.04.05.08.1.13.15.09.09.2.16.32.21s.25.08.38.08a1.05 1.05 0 0 0 .71-.29c.09-.09.17-.21.22-.33s.08-.25.08-.38c0-.26-.11-.52-.3-.71-.37-.37-1.04-.37-1.41 0m8.92 4-1.29 1.29v-4.59c0-.55-.45-1-1-1s-1 .45-1 1v4.59l-1.29-1.29a.996.996 0 1 0-1.41 1.41l3 3c.09.09.2.17.33.22.12.05.25.08.38.08s.26-.03.38-.08.23-.12.33-.22l3-3a.996.996 0 1 0-1.41-1.41z"
    />
  </svg>
);
export default SvgSortNewest;
